import Action from "./../../../formElements/Action/Action";
import arrowLeft from "../../../../images/arrow_left.svg";
import { Component } from "react";
import "./SidePanelSection.css";
import classnames from "classnames";
import { Translation } from "react-i18next";

const REDUCED_LIST_SIZE = 3;

export default class SidePanelSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: this.props.isReducedList
        ? this.props.list.slice(0, REDUCED_LIST_SIZE)
        : this.props.list,
      allIsVisible: !this.props.isReducedList,
    };
  }

  showAll = () => {
    this.setState({
      allIsVisible: true,
      list: this.props.list,
    });
  };

  render() {
    if (this.props.list.length === 0) {
      return null;
    }
    const TagName = this.props.tagName;
    return (
      <Translation>
        {t => (
          <div className="side-panel-section">
            {this.props.showBackArrow && (
              <span
                onClick={() => this.props.collapse && this.props.collapse()}
                className={classnames("side-panel-arrow", { link: this.props.collapse })}
              >
                <img src={arrowLeft} alt="arrow-left" />
                {t("Common.Back")}
              </span>
            )}
            {!this.props.isLessonPage && (
              <div className="side-panel-title">{this.props.sectionTitle}</div>
            )}
            <ul>
              {(this.props.isLessonPage ? this.props.sections : this.state.list).map(
                (item, index) => (
                  <TagName
                    key={index}
                    item={item}
                    open={this.props.open}
                    data={this.props.data}
                    loading={this.props.fetchLoading}
                    assignments={this.props.assignments}
                    fileName={this.props.fileName}
                    location={this.props.location}
                    refresh={this.props.refresh}
                    isLessonItem={this.props.isLessonPage}
                    onSectionActive={
                      this.props.isLessonPage ? this.props.onSectionActive : undefined
                    }
                  />
                )
              )}
            </ul>
            {!this.state.allIsVisible && this.props.list.length > REDUCED_LIST_SIZE && (
              <Action className="show-more" onClick={this.showAll}>
                {`${t("Common.showMore")} (` +
                  (this.props.list.length - REDUCED_LIST_SIZE) +
                  ")"}
              </Action>
            )}
          </div>
        )}
      </Translation>
    );
  }
}
